var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { workOrderDashboardDatePresetApiInternalUserPreferencesPath } from '@routes';
/**
 * PATCH /api/internal/user_preferences/work_order_dashboard_date_preset
 * Persists the user's chosen work-order dashboard date preset server-side.
 * For the 'custom' preset, start_date and end_date (ISO YYYY-MM-DD) are required.
 * Throws on network / 4xx / 5xx so callers can revert optimistic UI updates.
 */
export function patchWorkOrderDashboardPreset(presetId, customDates) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = { preset_id: presetId };
        if (presetId === 'custom' && customDates) {
            body.start_date = customDates.startDate;
            body.end_date = customDates.endDate;
        }
        yield api.patch(workOrderDashboardDatePresetApiInternalUserPreferencesPath({ format: 'json' }), body);
    });
}
